<template>
    <div :class="statusClass">
        <div class="te-cart__item__name">
            <span>{{name}}</span>
        </div>
        <div class="te-cart__item__price">
            <span>{{formattedPrice}}</span>
        </div>
        <div class="te-cart__item__quantity">
            <input v-if="editMode" class="te-form-control" type="number" name="quantity" min="0" :max="itemLimit" v-model="quantityClone" :tabindex="tabIndex" @change="onQuantityChange">
            <span v-if="!editMode">{{quantityClone}}</span>
        </div>
        <div v-if="disableCartEditing === false" class="te-cart__item__action">
            <button v-if="!editMode" class="te-button te-primary-action" data-cy="change" @click="toggleEditMode">{{languageSettings.change}}</button>
            <button v-if="editMode" class="te-button te-primary-action" data-cy="save" @click="onSave">{{languageSettings.save}}</button>
            <!--            <button v-if="editMode" class="te-button te-secondary-action" data-cy="cancel" @click="toggleEditMode">{{languageSettings.cancel}}</button>-->
        </div>
    </div>
</template>

<script>
    import format from '../services/format'

    export default {
        name: "CartItem",

        data() {
            return {
                editMode: false,
                quantityClone: 0,
            };
        },

        props: {
            name: {
                type: String,
                required: true
            },
            status: {
                type: String,
                required: true
            },
            currency: {
                // type: String,
                type: Object,
            },
            price: {
                type: Number,
            },
            quantity: {
                type: Number,
            },
            limit: {
                type: Number,
                default: null
            },
            // editMode: {
            //     type: Boolean,
            //     default: false
            // },
            disableCartEditing: {
                type: Boolean,
                default: false
            },
            tabIndex: {
                type: Number,
                default: 1
            },
            language: {
                type: Object
            },
        },

        computed: {
            statusClass: function() {
                return 'te-cart__item te-cart__item__status-' + this.status;
            },

            formattedPrice: function() {
                if(this.price === 0) return this.language.free;
                return format.price(this.currency, this.price*this.quantityClone);
            },

            itemLimit: function() {
                // return this.limit ? this.limit : this.quantityClone;
                // return this.quantity;
                return this.limit ? this.limit : 50;
            },

            languageSettings: function() {
                const defaultSettings = {
                    change: 'Change',
                    cancel: 'Cancel',
                    save: 'Save',
                };
                return Object.assign(defaultSettings, this.language);
            },
        },

        methods: {
          onQuantityChange() {
            if(this.quantityClone > this.itemLimit) {
              this.quantityClone = this.itemLimit;
            }
          },

            // onQuantityChange(event) {
            onSave() {
                // const quantity = event.target.value;
                // // if(this.itemLimit && this.quantityClone > this.itemLimit) this.quantityClone = this.itemLimit;
                // if(quantity > this.itemLimit) {
                //     this.quantityClone = this.itemLimit;
                // } else {
                //     this.quantityClone = quantity;
                // }
                this.toggleEditMode();
                if(this.quantityClone !== this.quantity) {
                    this.$emit('change', this.quantityClone);
                }
            },

            toggleEditMode() {
                this.editMode = !this.editMode;
                this.$emit('edit', this.editMode);
            },
        },

        watch: {
            quantity: function(q) {
                this.quantityClone = q;
            }
        },

        created() {
            if(this.quantity) {
                this.quantityClone = this.quantity;
            }
        }
    }
</script>

<style scoped>

</style>
